import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { DrawingMenuComponent } from '../../../drawing-menu/drawing-menu.component';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'pcp-slide-sync-toolbar-button-drawing-menu',
    templateUrl: './toolbar-button-drawing-menu.component.html',
    styleUrl: './toolbar-button-drawing-menu.component.scss',
    imports: [ToolbarButtonComponent, DrawingMenuComponent, NgClass, AsyncPipe]
})
export class ToolbarButtonDrawingMenuComponent {

    @Input() icon = 'apps';
    @Input() fontSet = '';

    readonly isDrawingMenuOpened$ = this.store.select(
        fromToolbar.isDrawingMenuOpened
    );

    readonly isDrawingEnabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    );

    constructor(
        private store: Store,
    ) { }

    toggleDrawingMenu() {
        this.store.dispatch(
            ToolbarActions.toggleDrawingMenu()
        );
    }
}
